import { API, Competition, CompetitionAPI, PageModel } from '@brg/api';
import urlApi from "./urlApi";

export interface getListProps {
  i18n: any
  competitionIds?: string[] 
  competitionStatus?: number[]
  limit?: number
  page?: number
};

export const getList = (props: getListProps) => {
  const { i18n, limit = 100, page = 0, ...rest } = props
  return CompetitionAPI.GetList({ limit, page, ...rest } as any)
    .then((value) => value.json())
    .then((v) => API.toLang<PageModel<Competition>>(v, i18n.language))
};

export const createNewTag = (data: any) => {
  return urlApi().createNewTag(data)
}

export const competitionService = {
  getList
};import { API, Competition, CompetitionAPI, PageModel } from '@brg/api';
import urlApi from "./urlApi";

export interface getListProps {
  i18n: any
  competitionIds?: string[] 
  competitionStatus?: number[]
  limit?: number
  page?: number
};

export const getList = (props: getListProps) => {
  const { i18n, limit = 100, page = 0, ...rest } = props
  return CompetitionAPI.GetList({ limit, page, ...rest } as any)
    .then((value) => value.json())
    .then((v) => API.toLang<PageModel<Competition>>(v, i18n.language))
};

export const createNewTag = (data: any) => {
  return urlApi().createNewTag(data)
}

export const competitionService = {
  getList
};